export default "__VITE_ASSET__BS34B9Dp__"